import { useEffect, useState } from "react";

const AutoCarousel = ({
  images,
  interval = 3000,
  transitionDuration = 700,
  pauseOnHover = false,
  height = "500px",
  objectFit = "cover",
  ariaLabel,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div
      className="relative w-full overflow-hidden"
      style={{ height }}
      aria-label={ariaLabel}
    >
      {/* Blurred background of current image */}
      <img
        src={images[currentIndex].src}
        alt=""
        className="absolute inset-0 w-full h-full object-cover blur-lg scale-110"
      />

      {/* Actual image */}
      <img
        src={images[currentIndex].src}
        alt={images[currentIndex].alt}
        className={`absolute inset-0 w-full h-full object-${objectFit} transition-opacity duration-${transitionDuration} ease-in-out`}
      />
    </div>
  );
};

export default AutoCarousel;
